.categories {
  max-width: 1600px;
  background-color: var(--color-white);
  padding: 15px;
  width: calc(100% - 30px);

  @media (min-width: 1280px) {
    padding: 50px;
    width: calc(100% - 100px);
  }

  @media (min-width: 1600px) {
    padding: 100px;
    width: calc(100% - 200px);
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 20px;
    grid-column-gap: 20px;

    @include breakpointMin('lg') {
        &.columns-3 {
          grid-template-columns: 1fr 1fr 1fr;
        }

        &.columns-4 {
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }
  }
}


